import React, { useState } from 'react';
import { useComponents } from '@tencent/dz-elements';
import { HospitalHeader, CardSpaceWrapper, TranformButton, ImagePreviewModal, HospitalModal } from '../../../components';
import { useMessageById, useConsultModel } from '../../../hooks';
import styles from './style/index.less';
import { useReportService } from './useReportService';
import { formateImageWebp } from '../../../utils';
var HospitalCard = function (props) {
    // 获取医院数据
    var messageId = props.messageId;
    var messageState = useMessageById(messageId);
    var _a = messageState.payload, _b = _a.content, content = _b === void 0 ? {} : _b, recommendMode = _a.recommendMode, nerMode = _a.nerMode;
    var report = useReportService({ content: content, recommendMode: recommendMode, nerMode: nerMode });
    // 获取配置的转化页卡信息
    var config = useConsultModel().getConsultConfig();
    var _c = useComponents(), View = _c.View, Image = _c.Image, Text = _c.Text;
    var _d = useState(false), showModal = _d[0], setShowModal = _d[1];
    var _e = useState(false), showImagePreview = _e[0], setShowImagePreview = _e[1];
    var _f = useState(0), currentIndex = _f[0], setCurrentIndex = _f[1];
    var onShowDetail = function () {
        report.hospitalClick();
        setShowModal(true);
        report.hospitalModalExposure();
    };
    // 预览图片
    var onShowImagePreview = function (e, index) {
        setCurrentIndex(index);
        setShowImagePreview(true);
        // 阻止事件冒泡
        e.stopPropagation();
    };
    var onHidePreview = function (e) {
        setShowImagePreview(false);
        // 阻止事件冒泡
        e.stopPropagation();
    };
    var backgroundImage = content.backgroundImage, desc = content.desc, environment = content.environment, id = content.id;
    var sessionNumStatEnable = config.card_session_num_stat_enable === 1;
    var consultSessionCount = config.search_consult_session_count || 0;
    return (React.createElement(View, { id: "card_" + id },
        React.createElement(CardSpaceWrapper, { className: styles['hospital-card'], onClick: onShowDetail },
            React.createElement(HospitalHeader, { hospitalData: content, type: "block" }, backgroundImage && (React.createElement(Image, { className: styles['search-header-img'], src: formateImageWebp(backgroundImage), imageWidth: 750, imageHeight: 350 }))),
            React.createElement(Text, { className: styles['search-card-desc'], content: desc }),
            React.createElement(View, { className: styles['search-divider'] }),
            environment && environment.length > 0 && (React.createElement(View, { className: styles['environment-image-container'] }, environment.map(function (img, index) { return (React.createElement(View, { key: index, className: styles['environment-image'] },
                React.createElement(Image, { src: formateImageWebp(img), imageWidth: 750, imageHeight: 422, onClick: (function (e) { return onShowImagePreview(e, index); }) }))); }))),
            React.createElement(View, { className: styles['consult-container'] },
                sessionNumStatEnable && (React.createElement(View, { className: styles['consult-num-container'] },
                    "\u7D2F\u8BA1",
                    React.createElement(Text, { className: styles['consult-num'], content: String(consultSessionCount) }),
                    "\u4EBA\u54A8\u8BE2")),
                React.createElement(TranformButton, { moduleParams: report.cardReportModuleParams.module }))),
        React.createElement(HospitalModal, { hospital: content, show: showModal, onHide: function () {
                setShowModal(false);
            } }),
        showImagePreview && (React.createElement(ImagePreviewModal, { images: environment, onHide: onHidePreview, defaultIndex: currentIndex }))));
};
export default HospitalCard;
